<script lang="ts">
  import { twJoin } from "tailwind-merge";
  import Card, { type CardProps } from "./Card.svelte";
  import SliderWrapper from "./SliderWrapper.svelte";
  export let cards: CardProps[] = [];
  export let startIndex: number = -1;
  import BookImage from "@components/content/BookImage.svelte";
  import ArticleCard from "./Card/ArticleCard.svelte";
  import { deriveBlurredBackgroundImageURLFromText } from "@utils/cdn";

  function formatDate(dateString: string): string {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  const images = [
    "https://b-cdn.wildatheart.org/files/articles/default-images/adam-azim-ed2fq0vxsca-unsplash.jpg",
    "https://b-cdn.wildatheart.org/files/articles/default-images/adam-kool-ndn00kmbj1c-unsplash.jpg",
    "https://b-cdn.wildatheart.org/files/articles/default-images/asa-rodger-b8xmtkwlrvo-unsplash.jpg",
    "https://b-cdn.wildatheart.org/files/articles/default-images/benjamin-davies-mqn-ev9rnly-unsplash.jpg",
  ];
</script>

<SliderWrapper {startIndex}>
  {#each cards as card}
    {#if card.variant === "book"}
      <a
        href={card.href}
        class={twJoin(
          "min-w-48 max-w-72 p-4 text-white flex flex-col items-center",
          "hover:scale-105 scale-100",
          card.classProp,
        )}
      >
        <BookImage
          url={card.featuredImageSrc}
          altText={card.title}
          class="h-72 object-scale-down"
        />
        <div class={twJoin("pt-8 text-center")}>
          <span class="wah-heading-5 text-s100">{card.title}</span>
        </div>
        <div class={twJoin("wah-body-base text-center")}>
          {card.subtitle}
        </div>
        {#if card.details}
          <div class={twJoin("wah-body-small text-center")}>
            {card.details}
          </div>
        {/if}
      </a>
    {:else if card?.collection?.handle === "blogs"}
      <Card
        title={card.title}
        description={card.description}
        avatar={{ name: card.author_name, imageSrc: card.author_image_src }}
        leader={`${formatDate(card.published_at)} • ${card?.collection?.title}`}
        featuredImageSrc={card.featured_image_src}
        backgroundImageSrc={deriveBlurredBackgroundImageURLFromText(
          card.title ?? "",
          card.featured_image_src ? [card.featured_image_src] : images,
        )}
        href={card.uri}
        tag={card.tag}
        details={card.details}
        trimDescriptionBool={card.trim_description_bool}
        isDisabled={card.is_coming_soon}
        variant={"blog-article"}
        date={card.published_at}
      />
    {:else}
      <Card {...card} class="embla_slide min-w-12" />
    {/if}
  {/each}
</SliderWrapper>
